import React from 'react'
import PropTypes from 'prop-types'

import { FormItem, FormLabel, TooltipDefinition } from 'carbon-components-react'
import Checkbox from '@ublique/components/Checkbox'

import './index.scss'

const MatrixUX = ({
  id,
  labelText,
  labelTooltip,
  disabled,
  invalid,
  invalidText,
  helperText,
  columns,
  data,
  selected,
  setSelected,
  multiple,
  canSelectAll,
  selectAll,
  onSelectAllChange,
  selectAllTooltip
}) => {
  const getHandleSelection = (value, isSelected) => () => {
    if (!multiple) {
      return setSelected(isSelected ? '' : value)
    }

    if (!isSelected) {
      return setSelected([...selected, value])
    }

    setSelected(selected.filter((element) => element !== value))
  }

  return (
    <FormItem
      id={id}
      disabled={disabled}
      className={`matrix ${disabled ? 'matrix--disabled' : ''} ${
        invalid ? 'matrix--invalid' : ''
      }`}
    >
      <FormLabel className='matrix__label' htmlFor={id}>
        <div className='matrix__label__text'>
          {canSelectAll && (
            <TooltipDefinition
              children={
                <Checkbox
                  id={`matrix-select-all--${id}`}
                  checked={selectAll}
                  onChange={onSelectAllChange}
                />
              }
              tooltipText={selectAllTooltip}
            />
          )}
          {labelText}
        </div>
        <div className='matrix__label__tooltip'>{labelTooltip}</div>
      </FormLabel>
      {helperText}
      <div
        className='matrix__container'
        style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}
      >
        {data.map(({ label, value }, j) => {
          const isSelected = multiple
            ? selected.find((element) => element === value)
            : value === selected
          return (
            <div
              className={`matrix__element ${
                isSelected ? 'matrix__element--selected' : ''
              }`}
              key={j}
              onClick={
                disabled ? undefined : getHandleSelection(value, isSelected)
              }
            >
              {label}
            </div>
          )
        })}
      </div>
      {invalid && <div className='matrix__invalidText'>{invalidText}</div>}
    </FormItem>
  )
}

MatrixUX.propTypes = {
  columns: PropTypes.number,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOf(PropTypes.string, PropTypes.number),
      value: PropTypes.oneOf(PropTypes.string, PropTypes.number)
    })
  ),
  id: PropTypes.string,
  labelText: PropTypes.string,
  disabled: PropTypes.bool,
  invalid: PropTypes.bool,
  helperText: PropTypes.string,
  invalidText: PropTypes.string,
  labelTooltip: PropTypes.node,
  selected: PropTypes.oneOf(PropTypes.string, PropTypes.array),
  setSelected: PropTypes.func,
  multiple: PropTypes.bool,
  canSelectAll: PropTypes.bool,
  selectAll: PropTypes.bool,
  onSelectAllChange: PropTypes.func,
  selectAllTooltip: PropTypes.node
}

export default MatrixUX
